module.exports = __webpack_public_path__ + "static/media/abbbaldor.2f3caae4.svg";